import React, { useState, useEffect } from 'react'
import commWhatsappImage from '../../../../../images/commWhatsappImage.jpeg'
import sampleCsv from '../../../../../images/sampleCsv.csv'
import Loader from '../../../../presentationals/Loader/Loader.component'
import { getWhatsappTemplatesList, UploadcampaginWhatsappWithcsv } from '../ActionCreator'
import Popup from '../../../../presentationals/Popup/Popup.component'
export default function Whatsapp() {
    const [loader, setLoader] = useState(false)
    const [uploadedCSV, setuploadedCSV] = useState('')
    const [csvFile, setcsvFile] = useState('')
    const [templateData, setTemplateData] = useState('')
    const [list, setList] = useState([])
    const [popup, setpopup] = useState({ show: false, popupStatus: '' })
    const [showTemplateData,setShowTempalteData] =useState({})

    useEffect(() => {
        getWhatsappTemplatesListFn()
    }, [])


    const downloadsample = () => {

        fetch(sampleCsv)
            .then(response => response.blob())
            .then(blob => {
                const link = document.createElement("a");
                link.href = URL.createObjectURL(blob);
                link.download = 'Sample';
                link.click();
            })
            .catch(console.error);

    }

    const uploadCsv = (e) => {
        let val = e.target.value.split(/[\\\/]/)[2];
        let docType = val.split(".");
        let fileType = docType[docType.length - 1];
        if (fileType == 'xls' || fileType == "xlsx") {
            setuploadedCSV(val)
            setcsvFile(e.target.files[0])
        }
        console.log("e",e.target.files)
        let File = e.target.files[0];
    }

    const getWhatsappTemplatesListFn = () => {
        setLoader(true)
        getWhatsappTemplatesList("", callback => {
            setLoader(false)
            if (callback && callback?.message == "success") {
                setList(callback?.data)
            } else {
                setList([])
            }
        })
    }

    const smsTemplateHandle = (e) => {
        console.log("e",e,e.target,e.target.value)
        setTemplateData(e.target.value)
        const data = list?.length > 0 ? list?.filter((el)=>el?.whatsappId == e.target.value) : {};
        setShowTempalteData(data?.[0])
    }

    const handleSubmit = () => {
        setLoader(true)
        UploadcampaginWhatsappWithcsv(showTemplateData?.whatsappId, "WHATSAPP", csvFile, callback => {
            setLoader(false)
            console.log("ca", callback)
            if (callback?.message == "success" && callback?.status == 200) {
                setShowTempalteData({})
                 setuploadedCSV("")
                 setTemplateData("")
            setcsvFile("")
                setpopup({ show: true, popupStatus: `Campaign Run Successfully for ${callback?.data ?? 0} Entry` })
            } else {
                setpopup({ show: true, popupStatus: 'Error Running Campaign' })
            }
            removePopup()
        })
    }

    const closePopup = () => {
        setpopup({ show: false, popupStatus: '' })
    }

    const removePopup = () => {
        setTimeout(() => {
            closePopup()
        }, 5000)
    }
    return (
        <>
            <div className="container-fluid marketing-css marketing-main-css">
                {
                    loader ? <Loader /> : ''
                }
                {
                    popup?.show ? <Popup popupStatus={popup?.popupStatus} closePopup={closePopup} /> : ''
                }
                <div className="row" style={{ marginTop: '50px' }}>
                    <div className="col-sm-6 col-xs-12">
                        <div>
                            <div className="inputTitle">Select Whatsapp Template</div>
                            <select
                                name="template"
                                onChange={(e) => smsTemplateHandle(e)}
                                id=""
                                value={templateData}
                                className="form-select w-100"
                                style={{
                                    minWidth: "165px",
                                    backgroundColor: "rgba(219, 233, 255, 0.70)",
                                    borderRadius: "6px",
                                }}
                            >
                                <option value="">Whatsapp Template</option>
                                {list?.length > 0 ? list?.map((data, i) => {
                                    return (
                                        <option value={data?.whatsappId}>{data?.whatsappSubject}</option>
                                    )
                                }) : ''}
                            </select>
                        </div>
                        {
                           showTemplateData && showTemplateData!== "" && Object.keys(showTemplateData)?.length > 0 ?
                                <>
                                    <div style={{marginTop:'15px'}}>
                                        <div className="inputTitle">Whatsapp Body</div>
                                        <textarea className='form-control' rows={5} value={showTemplateData?.whatsappText} disabled />
                                    </div>
                                    {
                                        csvFile!= "" && csvFile != null && csvFile!= undefined ? 
                                        <button
                                        title="SEND"
                                        style={{ width: '150px',marginTop:'20px' }}
                                        onClick={() => handleSubmit()}
                                        type="button"
                                        className="bulkCommSendBtn"
                                        >
                                        Save
                                    </button>
                                    :''}
                                </>
                                : ''}
                    </div>
                    <div className='col-sm-6 col-xs-12'>
                        <div style={{ borderRadius: '12px', border: '1px solid rgba(0, 0, 0, 0.10)', background: '#FAFAFA', padding: '10px' }}>
                            <div className=' ' style={{ padding: '15px', marginTop: '10px' }}>
                                <div className="upload-main" style={{ background: 'rgba(219, 233, 255, 0.70)' }}>
                                    <div className="image-upload-div" >
                                        <input
                                            onChange={(e) => uploadCsv(e)}
                                            style={{ padding: '20px' }}
                                            accept={'.xls,.xlsx'}
                                            className="file-upload-input" type='file' />
                                        <div className="drag-text-new" style={{ marginTop: '10px', color: 'rgba(0, 0, 0, 0.40)' }}>
                                            <h5 className="upload-icon" style={{ backgroundPosition: '30%' }}> {csvFile!= "" && csvFile != null && csvFile!= undefined ? csvFile?.name : 'upload XLSX'} </h5>
                                        </div>
                                    </div>
                                </div>

                            </div>
                            <h4 style={{ marginLeft: '35px' }}><strong>Excel Sample File </strong></h4>
                            <img src={commWhatsappImage} style={{ width: '100%' }} />
                            <div style={{ color: '#FF772B', background: '#FFF2EA', padding: '10px', borderRadius: '5px', marginTop: '10px', marginBottom: '20px', width: '80%', marginLeft: 'auto', marginRight: 'auto' }}>Please ensure that the Excel file with data of User should be in this format.</div>
                            <div className='text-center'>
                                <button onClick={() => downloadsample()} className='btn btn-primary'><i class="fa fa-download" aria-hidden="true"></i>&nbsp;&nbsp;Download CSV Sample File </button></div>
                        </div>
                    </div>
                </div>
            </div>
        </>
    )
}
